import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTableIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M5.616 20q-.69 0-1.153-.462-.462-.462-.463-1.154V5.616q0-.69.463-1.153A1.57 1.57 0 0 1 5.616 4h12.769q.69 0 1.153.463T20 5.616v12.769q0 .69-.462 1.153T18.384 20zM5 8.998h14V5.616a.6.6 0 0 0-.192-.424.58.58 0 0 0-.424-.192H5.616a.6.6 0 0 0-.424.192.58.58 0 0 0-.192.424zm0 5.004h14V9.998H5zM5.616 19h12.769a.6.6 0 0 0 .423-.192.58.58 0 0 0 .192-.424v-3.382H5v3.382q0 .23.192.424a.58.58 0 0 0 .423.192M6.77 7.804V6.188h1.615v1.616zm0 5.004v-1.616h1.615v1.616zm0 5.003v-1.615h1.615v1.615z"
    />
  </svg>
)
export default SvgTableIcon
